<template lang="pug">
  app-modal(v-model="visible" :title="title" :width="1200" :confirm-loading="loading" @ok="handleSubmit" @cancel="hide")
    app-form(:model="model" :rules="rules" ref="form" oneline :labelWidth="90")  
      a-row(:gutter="16")
        a-col(:sm="8")    
          a-form-model-item(label="商家" prop="vendorId" )
            app-remote-select(v-model="model.vendorId" api="/prj/vendor-user-mappings/list" :params="params" allow-clear placeholder="请选择商家")
          
        a-col(:sm="8")    
          a-form-model-item(label="联系电话" prop="pickupAddress" )
            a-input(v-model="model.pickupAddress" allow-clear :max-length="100" placeholder="请输入商家联系电话")
        a-col(:sm="8")    
          a-form-model-item(label="商家地址" prop="pickupAddress" )
            a-input(v-model="model.pickupAddress" allow-clear :max-length="100" placeholder="请输入商家地址")


        a-col(:sm="8")    
          a-form-model-item(label="客户姓名" prop="customerName" )
            a-input(v-model="model.customerName" allow-clear :max-length="100" placeholder="请输入客户姓名")
        
        a-col(:sm="8")    
          a-form-model-item(label="客户手机" prop="customerMobile" )
            a-input(v-model="model.customerMobile" allow-clear :max-length="100" placeholder="请输入客户手机")
        
        a-col(:sm="8")    
          a-form-model-item(label="客户地址" prop="customerAddress" )
            a-input(v-model="model.customerAddress" allow-clear :max-length="100" placeholder="请输入客户地址")
        a-col(:sm="8")    
          //- （出入库、服务）
          a-form-model-item(label="订单类型" prop="orderType" )
            app-remote-select(
              placeholder="请选择订单类型"
              v-model="model.orderType" 
              api="/prj/vendors/list" 
              :params="params" 
              allow-clear 
            )
        
        a-col(:sm="8")    
          a-form-model-item(label="订单子类型" prop="orderSubType" )
            app-remote-select(
              placeholder="请选择订单子类型"
              v-model="model.orderSubType" 
              api="/prj/vendors/list" 
              :params="params" 
              allow-clear 
            )
        a-col(:sm="8")    
          //- （点位、计件）
          a-form-model-item(label="收费模式" prop="feeMode" )
            app-remote-select(
              placeholder="请选择订收费模式"
              v-model="model.feeMode" 
              api="/prj/vendors/list" 
              :params="params" 
              allow-clear 
            )
        
        a-col(:sm="8")    
          a-form-model-item(label="订单金额" prop="amount" )
            a-input-number(v-model="model.amount" allow-clear :min="0" placeholder="请输入订单金额")
        a-col(:sm="8")    
          //- （仅财务可见）
          a-form-model-item(label="服务费用" prop="serviceFee" )
            a-input-number(v-model="model.serviceFee" allow-clear :min="0" placeholder="请输入服务费用")
    
        a-col(:sm="16")    
          a-form-model-item(label="提货地址" prop="pickupAddress" )
            a-input(v-model="model.pickupAddress" allow-clear :max-length="100" placeholder="请输入提货地址")
        
        a-col(:sm="8")    
          a-form-model-item(label="预约送货时间" prop="appointmentTime" )
            a-input(v-model="model.appointmentTime" allow-clear :max-length="100" placeholder="请输入预约送货时间")
        
        a-col(:sm="24")                    
          a-form-model-item(label="商家备注信息" prop="vendorComments" )
            a-textarea(v-model="model.vendorComments" allow-clear :max-length="100" placeholder="请输入商家备注")
    
      //- a-form-model-item(label="出入库类型" prop="stockType" )
      //-   a-input(v-model="model.stockType" allow-clear :max-length="100" placeholder="请输入出入库类型")
    
      //- a-form-model-item(label="出入库子类" prop="stockSubType" )
      //-   a-input(v-model="model.stockSubType" allow-clear :max-length="100" placeholder="请输入出入库子类")
    
      //- a-form-model-item(label="出入库时间" prop="stockTime" )
      //-   a-input(v-model="model.stockTime" allow-clear :max-length="100" placeholder="请输入出入库时间")
  
      //- a-form-model-item(label="商家备注" prop="vendorComments" )
        a-textarea(v-model="model.vendorComments" allow-clear :max-length="100" placeholder="请输入商家备注")
    
      //- a-form-model-item(label="接单员备注" prop="takerComments" )
        a-textarea(v-model="model.takerComments" allow-clear :max-length="100" placeholder="请输入接单员备注")
    
      //- a-form-model-item(label="库管备注" prop="keeperComments" )
      //-   a-textarea(v-model="model.keeperComments" allow-clear :max-length="100" placeholder="请输入库管备注")
    
      //- a-form-model-item(label="调度员备注" prop="schedulerComments" )
      //-   a-textarea(v-model="model.schedulerComments" allow-clear :max-length="100" placeholder="请输入调度员备注")
    
      //- a-form-model-item(label="处理岗位ID" prop="dutyPostId" )
      //-   app-remote-select(v-model="model.dutyPostId" api="/prj/brands/list" :params="params" allow-clear placeholder="请选择处理岗位ID")
    
      //- a-form-model-item(label="处理用户ID" prop="dutyUserId" )
      //-   app-remote-select(v-model="model.dutyUserId" api="/prj/brands/list" :params="params" allow-clear placeholder="请选择处理用户ID")
    
      //- a-form-model-item(label="已配车辆" prop="carArranged" )
      //-   a-input(v-model="model.carArranged" allow-clear :min="0" placeholder="请输入已配车辆")
    
      //- a-form-model-item(label="状态（带提交、待确认、处理中、已完成）" prop="status" )
      //-   a-input(v-model="model.status" allow-clear :max-length="100" placeholder="请输入状态（带提交、待确认、处理中、已完成）")
        
      //-     //- a-form-model-item(label="名称" prop="name" )
      //-     //-   a-input(v-model="model.name" allow-clear :max-length="30" placeholder="请输入订单名称")
            
        
</template>

<script>
import { GETTER_PROJECT, GETTER_USER } from '@store/account';
import { mapGetters } from 'vuex';
// import InspItemCreateAndEdit from './InspItemCreateAndEdit';
export default {
  name: 'CreateAndEdit',
  components: {
    // InspItemCreateAndEdit,
  },
  data() {
    return {
      visible: false,
      loading: false,
      title: '添加订单',
      model: {
        vendorId: null,
        orderType: null,
        orderSubType: null,
        feeMode: null,
        amount: null,
        serviceFee: null,
        pickupAddress: null,
        appointmentTime: null,
        customerName: null,
        customerMobile: null,
        customerAddress: null,
        stockType: null,
        stockSubType: null,
        stockTime: null,
        vendorComments: null,
        takerComments: null,
        keeperComments: null,
        schedulerComments: null,
        dutyPostId: null,
        dutyUserId: null,
        carArranged: null,
        status: null,
      },
      rules: {
        vendorId: [{ required: true, message: '必填项' }],
        orderType: [{ required: true, message: '必填项' }],
        orderSubType: [{ required: true, message: '必填项' }],
        feeMode: [{ required: true, message: '必填项' }],
        amount: [{ required: true, message: '必填项' }],
        serviceFee: [{ required: true, message: '必填项' }],
        pickupAddress: [{ required: true, message: '必填项' }],
        customerName: [{ required: true, message: '必填项' }],
        customerMobile: [{ required: true, message: '必填项' }],
        customerAddress: [{ required: true, message: '必填项' }],
        stockType: [{ required: true, message: '必填项' }],
        stockSubType: [{ required: true, message: '必填项' }],
        vendorComments: [{ required: true, message: '必填项' }],
        takerComments: [{ required: true, message: '必填项' }],
        keeperComments: [{ required: true, message: '必填项' }],
        schedulerComments: [{ required: true, message: '必填项' }],
        dutyPostId: [{ required: true, message: '必填项' }],
        dutyUserId: [{ required: true, message: '必填项' }],
        carArranged: [{ required: true, message: '必填项' }],
        status: [{ required: true, message: '必填项' }],
      },
    };
  },
  computed: {
    ...mapGetters({
      project: GETTER_PROJECT,
      user: GETTER_USER,
    }),
    params() {
      return {
        projectId: this.project.id,
      };
    },
  },
  mounted() {},
  methods: {
    show(model, action) {
      // this.$refs.form.resetFields();
      this.model = {
        ...this.model,
        ...model,
      };
      this.action = action;
      this.title = model === undefined ? '添加订单' : '编辑订单';
      this.visible = true;
    },
    hide() {
      this.visible = false;
      this.$refs.form.resetFields();
      this.model = {
        vendorId: null,
        orderType: null,
        orderSubType: null,
        feeMode: null,
        amount: null,
        serviceFee: null,
        pickupAddress: null,
        appointmentTime: null,
        customerName: null,
        customerMobile: null,
        customerAddress: null,
        stockType: null,
        stockSubType: null,
        stockTime: null,
        vendorComments: null,
        takerComments: null,
        keeperComments: null,
        schedulerComments: null,
        dutyPostId: null,
        dutyUserId: null,
        carArranged: null,
        status: null,
      };
      // this.$refs.item.handleCancel();
    },
    async handleSubmit() {
      const valid = await this.$refs.form.validate();
      if (valid) {
        this.loading = true;
        this.$restful(`save:/prj/orders/vendor`, {
          ...this.model,
          projectId: this.project.id,
        })
          .then(() => {
            this.$message.success(this.title + '成功!');
            this.$emit('modal-success');
            this.hide();
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    handleInspTypeChange() {
      this.model.targetKeys = null;
    },
    handleDleteItem(itemId) {
      this.model.rmItemIds.push(itemId);
    },
    handleClickAddItem() {
      this.$refs.form.clearValidate(['itemDTOS']);
    },
  },
};
</script>

<style lang="less" scoped>
.checkbox-item {
  padding-left: 90px;
  margin: -10px 0 16px 0;
}
.insp-item-list {
}
</style>
